<div class="instructions-card bg-white p-5 w-100 max-400 border-radius-10 m-auto mrb-10 mrb-md-0 box-shadow">
    <div class="d-flex justify-content-between text-center">
      <div class="col-md-6 col-6">
          <div class="instructions-card-img"><img class="w-100 max-180 rounded-top" [src]="beforeImage"
                  alt="card img" defaultImage></div>
          <div class="instructions-card-body">
              <div class="instructions-card-title text-center size-9 weight-700 ptb-10 pse-5">{{ 'service.before' | translate }}</div>
          </div>
      </div>
        <div class="col-md-6 col-6">
            <div class="instructions-card-img"><img class="w-100 max-180 rounded-top" [src]="afterImage" alt="card img" defaultImage>
            </div>
            <div class="instructions-card-body">
                <div class="instructions-card-title text-center size-9 weight-700 ptb-10 pse-5">{{ 'service.after' | translate }}</div>
            </div>
        </div>
    </div>
</div>
